/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * Emulation API
 * work with virtual devices
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * responses reason
 * @export
 * @enum {string}
 */
export enum ResponseReason {
    Ok = 'ok',
    InvalidField = 'invalid_field',
    NoData = 'no_data',
    NotFound = 'not_found',
    NotImplemented = 'not_implemented',
    ServerError = 'server_error'
}

